import styled from "styled-components";

export const RegisteredParticipantsTabContainer = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }
`;
